export const initializeDropdowns = () => {
    initializeBaseDropdown();
    initializeVendorDropdown();
}

const initializeBaseDropdown = () => {
    const $dropdowns = $('.js-dropdown');

    $.each($dropdowns, (index, element) => {
        const $element = $(element);

        if ($element.data('kendoDropDownList')) return;

        $element.kendoDropDownList();
    })
}

const initializeVendorDropdown = () => {
    const $dropdowns = $('input.js-vendor-dropdown');

    if (!$dropdowns.length || $dropdowns.data('kendoDropDownList')) return;

    $.each($dropdowns, (index, dropdown) => {
        const $dropdown = $(dropdown);

        if ($dropdown.data('kendoDropDownList')) return;

        const dropdownData = new kendo.data.DataSource({
            serverFiltering: false,
            transport: {
                read: {
                    type: 'post',
                    url: '/AutoComplete/VendorAutoComplete'
                }
            }
        });

        $dropdowns.kendoDropDownList({
            placeholder: 'Search Vendors...',
            dataTextField: "Name",
            filter: 'contains',
            dataSource: dropdownData,
            width: '100%'
        });
        
        dropdownData.fetch()
            .then(() => populateDefaultValue($dropdown, 'Name'));
    });

}

const populateDefaultValue = ($element, compareAttributeName = 'value') => {
    const value = $element.data('value').toString();
    const k_dropdown = $element.data('kendoDropDownList');
    const data = k_dropdown.dataSource.data();
    const selection = data.find(item => {
        return item[compareAttributeName] === value
    });
    if (selection) {
        const selectionIndex = data.indexOf(selection);
        k_dropdown.select(selectionIndex);
    }
}